/** App shell: header, left parameter column, right tabbed view pane. */
import { view } from "./state/store";
import { Panel } from "./ui/common";
import { FillSelector } from "./ui/FillSelector";
import { ParamForm } from "./ui/ParamForm";
import { ConductorPanel } from "./ui/ConductorPanel";
import { ResultsPanel } from "./ui/ResultsPanel";
import { SchematicView } from "./ui/SchematicView";
import { FieldView } from "./ui/FieldView";
import { RlgcPanel } from "./ui/RlgcPanel";

const TABS = [
  { id: "xsec", label: "Cross-section" },
  { id: "field", label: "Field" },
  { id: "rlgc", label: "Loss / RLGC" },
] as const;

export function App() {
  return (
    <>
      <header>
        <h1>
          Impedance Lab <span>— coaxial line calculator</span>
        </h1>
      </header>
      <div class="main-grid">
        <div class="left-col">
          <Panel title="Fill type">
            <FillSelector />
          </Panel>
          <Panel title="Geometry & dielectric">
            <ParamForm />
          </Panel>
          <Panel title="Conductors">
            <ConductorPanel />
          </Panel>
          <Panel title="Results">
            <ResultsPanel />
          </Panel>
        </div>
        <div class="right-col">
          <Panel>
            <div class="view-tabs">
              {TABS.map((t) => (
                <button key={t.id} class={`view-tab ${view.value === t.id ? "active" : ""}`} onClick={() => (view.value = t.id)}>
                  {t.label}
                </button>
              ))}
            </div>
            {view.value === "xsec" && <SchematicView />}
            {view.value === "field" && <FieldView />}
            {view.value === "rlgc" && <RlgcPanel />}
          </Panel>
        </div>
      </div>
    </>
  );
}
